module.exports = __webpack_public_path__ + "img/salesman_index_withdrawPop_bg.c7d00c0c.png";